<template>
  <div class="steps">
    <b-row align-v="center">
      <b-col lg="3" cols="8">
        <div class="p-medium-gray-700-uppercase">Check-up Energetico</div>
      </b-col>
      <b-col lg="2" cols="4" class="text-right" order-lg="3">
        <div class="p-medium-gray-700-uppercase">{{ current }}/{{ steps }}</div>
      </b-col>
      <b-col class="lg:my-0 my-2" order-lg="2">
        <div class="steps-line" :class="'steps-'+steps">
          <div class="point" :class="{hover: step < current, active: step == current}" v-for="step in steps" :key="step" @click="backStep(step)"><span></span></div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "StepsLineComponent",
  props:{
    steps:{
      type: Number,
      required: true,
    },
    current:{
      type: Number,
      default: 1,
    },
  },
  methods:{
    backStep(step){
      if(step < this.current){
        this.$emit('changeCurrent', step)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.steps-line {
  display: flex;
  justify-content: space-between;

  .point {
    position: relative;
    flex-grow: 1;
    flex-basis: 1em;

    & > span {
      content: '';
      height: 16px;
      width: 16px;
      border-radius: 50%;
      border: 1px solid #99AAB5;
      background: #FFF;
      display: block;
      margin: 0 auto;
      z-index: 10;
      position: relative;

      transition: all 0.5s ease;

      &:after {
        content: '';
        height: 8px;
        width: 8px;
        border-radius: 50%;
        background: #0090DF;
        display: block;
        position: absolute;
        top: calc(50% - 4px);
        left: calc(50% - 4px);
        opacity: 0;

        transition: all 0.5s ease;
      }
    }

    &:first-child {
      & > span {
        margin-left: 0;
      }
    }

    &:last-child {
      & > span {
        margin-right: 0;
      }
    }

    & + .point {
      flex-shrink: 1;

      &:before {
        content: '';
        height: 1px;
        background: #99AAB5;

        width: 140%;
        position: absolute;
        right: calc(50% + 8px);
        top: calc(50% - 1px);
        z-index: 1;

        transition: all 0.5s ease;
      }

      &:last-child {
        &:before {
          right: 16px;
        }
      }
    }

    &.active {
      & > span {
        &:after {
          opacity: 1;
        }
      }
    }

    &.active, &.hover {
      & > span {
        cursor: pointer;
        border-color: #191C21;
      }

      &:before {
        background: #191C21;
      }
    }
  }

  &.steps-2{
    .point {
      & + .point {
        &:before {
          width: 190%;
        }
      }
    }
  }
  &.steps-4{
    .point {
      & + .point:nth-child(3) {
        &:before {
          width: 100%;
        }
      }
    }
  }
  &.steps-5{
    .point {
      & + .point:nth-child(3), & + .point:nth-child(4) {
        &:before {
          width: 100%;
        }
      }
    }
  }
}
</style>